import * as React from 'react';
import Select from 'react-select';

interface INestedOption {
  label: string;
  value: string;
  children?: INestedOption[];
}

interface IOption {
  label: string;
  value: string;
}

export const NestedMultiselectFormControl: React.FC<{
  disabled?: boolean;
  placeholder?: string;
  options: INestedOption[];
  selectedValues: string[];
  onChange(selectedValues: string[]): void;
}> = ({ disabled, placeholder, options, selectedValues, onChange }) => {
  // Flatten nested options for react-select
  const flatOptions: IOption[] = React.useMemo(() => {
    const flattened: IOption[] = [];
    options.forEach((parent) => {
      if (Array.isArray(parent.children) && parent.children.length > 0) {
        parent.children.forEach((child) => {
          flattened.push({
            label: `${parent.label} - ${child.label}`,
            value: `${parent.value}:${child.value}`,
          });
        });
      } else {
        flattened.push({
          label: parent.label,
          value: parent.value,
        });
      }
    });
    return flattened;
  }, [options]);

  const value = React.useMemo(() => {
    const selected = new Set(selectedValues);
    return flatOptions.filter((option) => selected.has(option.value));
  }, [selectedValues, flatOptions]);

  return (
    <Select
      isMulti
      classNamePrefix="Select"
      options={flatOptions}
      value={value}
      onChange={(selections: any) => {
        onChange((selections as IOption[]).map((option) => option.value));
      }}
      placeholder={placeholder}
      isDisabled={disabled}
    />
  );
};
